/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown>, cost: NonNullable<unknown>, cap: NonNullable<unknown> }} Assistant_Agent_Overage_LineInputs */



/**
* | output |
* | --- |
* | "Overage: {credits} credits (${cost}) of your ${cap} limit" |
*
* @param {Assistant_Agent_Overage_LineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_agent_overage_line = /** @type {((inputs: Assistant_Agent_Overage_LineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Agent_Overage_LineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Excédent : ${i?.credits} crédits ($${i?.cost}) de votre limite de $${i?.cap}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Überschreitung: ${i?.credits} Gutschriften ($${i?.cost}) Ihres $${i?.cap} Limits`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Eccedenza: ${i?.credits} crediti ($${i?.cost}) del tuo limite di $${i?.cap}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Превышение лимита: ${i?.credits} кредитов ($${i?.cost}) от вашего лимита в $${i?.cap}.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Exceso: ${i?.credits} créditos ($${i?.cost}) de su límite de $${i?.cap}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`超额：您的 $${i?.cap} 限额的 ${i?.credits} 积分（$${i?.cost}）`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`超過分：$${i?.cap}の上限のうち、${i?.credits}クレジット（$${i?.cost}）が超過しています。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`अतिरिक्त उपयोग: आपकी $${i?.cap} सीमा में से ${i?.credits} क्रेडिट ($${i?.cost})`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Excedente: ${i?.credits} créditos ($${i?.cost}) do seu limite de $${i?.cap}`)
	return /** @type {LocalizedString} */ (`Overage: ${i?.credits} credits ($${i?.cost}) of your $${i?.cap} limit`)
});